import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { RecommendationService } from '../../../../core/services/recommendation.service';
import { FuseNavigationService } from '../../../../core/components/navigation/navigation.service';

@Component({
  selector: 'favorite',
  templateUrl: './favorite.component.html',
  styleUrls: ['./favorite.component.scss'],
  standalone: false,
  animations: fuseAnimations
})

export class FavoriteComponent implements OnInit {
  currentIndex = 0;
  favorites: any = [];
  loading = true;
  constructor(private recommendationService: RecommendationService, private navigationService: FuseNavigationService) { }
  ngOnInit() {
    this.getFavorites();
  }

  getFavorites(): void {
    this.recommendationService.recommendations('favorite').subscribe((favorite: any) => {
      this.favorites = favorite;
      this.loading = false;
    })
  }

  scrollCarousel(direction) {
    const carousel = document.getElementById('carousel');
    const cards = carousel.children;
    const total = cards.length;

    this.currentIndex += direction;

    if (this.currentIndex < 0) this.currentIndex = 0;
    if (this.currentIndex >= total) this.currentIndex = total - 1;

    const offset = -this.currentIndex * 100;
    carousel.style.transform = `translateX(${offset}%)`;
  }

  deleteFavorite(index: number) {
    this.favorites.splice(index, 1);
    if (this.currentIndex > 0) this.scrollCarousel(-1);
  }
}
